export const InlineSpinner = ({
  className = "relative",
  text = null,
  color = "#00bbd6",
  thickness = 1,
  size = 32,
}) => (
  <div className="flex items-center space-x-2">
    <div
      className={`${className} flex justify-center flex-col items-center z-30`}
    >
      <div className="lds-ring" style={{ width: size, height: size }}>
        <div
          style={{
            width: size,
            height: size,
            borderWidth: thickness,
            borderColor: `${color} transparent transparent transparent`,
          }}
        />
        <div
          style={{
            width: size,
            height: size,
            borderWidth: thickness,
            borderColor: `${color} transparent transparent transparent`,
          }}
        />
        <div
          style={{
            width: size,
            height: size,
            borderWidth: thickness,
            borderColor: `${color} transparent transparent transparent`,
          }}
        />
        <div
          style={{
            width: size,
            height: size,
            borderWidth: thickness,
            borderColor: `${color} transparent transparent transparent`,
          }}
        />
      </div>
    </div>

    {text === null ? null : <div className="text-gray-600 text-xs">{text}</div>}
  </div>
);

export default ({ className = "", ...rest }) => (
  <div
    className={`absolute inset-0 flex justify-center flex-col items-center z-30 ${className}`}
  >
    <InlineSpinner text="Loading..." {...rest} />
  </div>
);
